import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  Button,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneShopping } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiDollarSign, FiPlus } from "react-icons/fi";
import { FaShoppingBag } from "react-icons/fa";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const shopping: any = getOneShopping();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const shopping_id = shopping?.shopping_id;
  const [title, setTitle] = useState<any>(shopping?.title);
  const [thumbnail, setThumbnail] = useState<any>(shopping?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(shopping?.image_cdn_id);
  const [venue, setVenue] = useState<any>(shopping?.venue);
  const [startTime, setStartTime] = useState<any>(shopping?.start_time);
  const [endTime, setEndTime] = useState<any>(shopping?.end_time);
  const [email, setEmail] = useState<any>(shopping?.email_address);
  const [payLink, setPayLink] = useState<any>(shopping?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(shopping?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(shopping?.whatsapp);
  const [facebook, setFacebook] = useState<any>(shopping?.facebook);
  const [twitter, setTwitter] = useState<any>(shopping?.twitter);
  const [instagram, setInstagram] = useState<any>(shopping?.instagram);
  const [youtube, setYoutube] = useState<any>(shopping?.youtube);
  const [hashtags, setHashtags] = useState<any>(shopping?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(
    shopping?.google_map_code
  );
  const [latitude, setLatitude] = useState<any>(shopping?.latitude);
  const [longitude, setLongitude] = useState<any>(shopping?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    shopping?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(shopping?.featured);
  const [promoted, setPromoted] = useState<any>(
    shopping?.promoted ? shopping?.promoted : "no"
  );
  const [shoppingStatus, setShoppingStatus] = useState<any>(shopping?.status);
  const [description, setDescription] = useState<any>(shopping?.description);
  const [expo, setExpo] = useState<any>(shopping?.expo);
  const [pricing, setPricing] = useState<any>(shopping?.Pricings);

  const [showModal, setShowModal] = useState(false);
  const [collection, setCollection] = useState<any>(
    shopping?.WhatIsArounds ? shopping?.WhatIsArounds : []
  );
  const shoppingRoutes = "/data/shopping";
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneShoppingHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : shopping?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: shoppingStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      pricing: pricing,
      subdata: collection?.length > 0 ? collection : [],
    };

    const { message, status } = await updateOneContent({
      data_id: shopping_id,
      data: data,
      content: _TYPES_.SHOPPING,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={shoppingRoutes}
      eyebrow="DoSee Data • Shopping"
      title="Edit Shopping"
      subtitle={`Update a shopping destination in ${entry_label || "this destination"}.`}
      icon={<FaShoppingBag className="h-5 w-5" />}
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneShoppingHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Storefront, mall or boutique photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.SHOPPINGS)}
        />
      </AddSection>

      <AddSection title="Shopping Details" hint="Name, venue and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Operating Hours"
        hint="When the venue is open."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="shopping_status"
        setStatus={setShoppingStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={shoppingStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Additional Details"
        hint="Optional sub-collections like brands or featured items."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <Button
          props={{
            type: "button",
            title: "Add More Details",
            category: "default",
            action: "add",
            onClick: () => setShowModal(true),
          }}
        />
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
